import Vue from 'vue'
import VueRouter from 'vue-router';
import App from './App.vue'

import { LayoutPlugin, NavbarPlugin, ButtonPlugin, FormCheckboxPlugin, IconsPlugin } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import 'aos/dist/aos.css';
import AOS from 'aos';

import Home from './Pages/Home.vue';
import Digger from './Pages/Digger.vue';
import Suggestion from './Pages/Suggestion.vue';

AOS.init({
  once: true,
  disable: true,
  delay: 0
});

Vue.use(LayoutPlugin);
Vue.use(NavbarPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormCheckboxPlugin);
Vue.use(IconsPlugin);
Vue.use(VueRouter); 

Vue.config.productionTip = false;

const routes = [
  { path: '/', component: Home },
  { path: '/dig', component: Digger},
  { path: '/suggestion', component: Suggestion}
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
